/**
 * LocalBusiness JSON-LD for KREAPP SAS, the legal entity publishing Thiia.
 * Facts mirror the legal notice (mentions légales) — keep both in sync.
 */
export const LOCAL_BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://thiia.app/#localbusiness",
  name: "KREAPP SAS",
  legalName: "KREAPP SAS",
  alternateName: "Thiia",
  url: "https://thiia.app/",
  logo: "https://thiia.app/favicon.png",
  image: "https://thiia.app/og-image.jpg",
  email: "hello@thiia.app",
  description:
    "KREAPP SAS édite Thiia, l'agent IA souverain de prospection pour coachs, indépendants et petites équipes.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "8 Le Hameau Saint Hubert",
    postalCode: "78860",
    addressLocality: "Saint-Nom-la-Bretèche",
    addressRegion: "Île-de-France",
    addressCountry: "FR",
  },
  areaServed: ["FR", "BE", "CH", "LU", "CA"],
  vatID: "FR91437834400016",
  identifier: "914 378 344",
  founder: { "@type": "Person", name: "Samir Salibi" },
  contactPoint: {
    "@type": "ContactPoint",
    email: "hello@thiia.app",
    contactType: "customer support",
    availableLanguage: ["French", "English"],
  },
  sameAs: ["https://www.thiia.app", "https://linkedin.com/company/thiia", "https://x.com/thiia_ai"],
} as const;
